import { setupForDark } from '@theme';
import classNames from 'classnames';

function Divider({
  text,
  textPosition = 'right',
  className = ''
}: {
  text: string;
  textPosition?: 'center' | 'left' | 'right';
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'flex items-center gap-sm py-xs w-full',
        setupForDark('text-secondary'),
        className
      )}
    >
      {(textPosition === 'right' || textPosition === 'center') && (
        <div className={classNames('h-[1px] flex-grow', setupForDark('bg-secondary'))}></div>
      )}
      <div className='L4R'>{text}</div>
      {(textPosition === 'left' || textPosition === 'center') && (
        <div className={classNames('h-[1px] flex-grow', setupForDark('bg-secondary'))}></div>
      )}
    </div>
  );
}

export default Divider;
